import React from 'react';
import { useInvokeAction } from '@leagueplatform/masonry';

type UsePaginationActionParams = {
  from?: string;
  nodeIds: string[];
};

export function usePaginationAction({
  from,
  nodeIds,
}: UsePaginationActionParams) {
  const invokeAction = useInvokeAction();

  const paginationAction = React.useCallback(
    (event: React.SyntheticEvent) => {
      invokeAction({
        event,
        type: 'reload',
        namespace: 'default',
        payload: {
          renderIntermediately: 'self',
          nodeIds,
          extraQueryParams: from ? [{ key: 'from', value: from }] : undefined,
        },
      });
    },
    [invokeAction, nodeIds, from],
  );

  return paginationAction;
}
